<template>
  <div>

    <vue-good-table
        :columns="columns"
        :rows="onBoardingReturnedRequests"
        class="table-word-wrap"
        :pagination-options="{enabled: this.paginationEnabled, ...paginationOptions}"
    >
      <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field === 'caseNumber'">
                              <span class="solution-link" @click="$emit('onViewCaseDetails', props.row.caseNumber)"> {{ props.row.caseNumber }} </span>
                            </span>
        <span v-else-if="props.column.field === 'actions'">
                                <div class="content row-content" v-if="props.row.requestSubmissionType !== exceptionRequestExitPoint">
                                  <span @click="loadDataInForm(props.row.id)" class="solution-link"> Edit </span>
                                </div>
                            </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { mapGetters } from "vuex";
import VGT_PAGINATION_OPTIONS from "../store/vgtPaginationOptions";
import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";

export default {
  name: "ReturnedRequestsList",
  components: {VueGoodTable},
  methods: {
    loadDataInForm(id) {
      this.$hhMixpanel.trackEvent("Edit returned request case consumed")
      this.$router.push({name: "ReturnedRequestIntakeForm", params: { id } })
    },
  },
  data() {
    return {
      paginationOptions: VGT_PAGINATION_OPTIONS.RETURNED_REQUESTS_LIST_PAGINATION_OPTIONS,
      exceptionRequestExitPoint: EXCEPTION_SUBMISSION_CONSTANTS.EXIT_POINT
    }
  },
  computed: {
    ...mapGetters(["onBoardingReturnedRequests"]),
    paginationEnabled() {
      return this.onBoardingReturnedRequests.length > 5
    },
    columns() {
      return [
        {
          label: "Case",
          field: "caseNumber",
          type: "string",
          thClass: "width-sm",
          tdClass: "align-left",
          width: "15%"
        },
        {
          label: "Request type",
          field(rowObj) {
            if(rowObj.requestSubmissionType === EXCEPTION_SUBMISSION_CONSTANTS.EXIT_POINT)
              return "Exception submission"
            return "Supplier engagement"
          },
          type: "string",
          thClass: "width-sm",
          tdClass: "align-left",
          width: "25%"
        },
        {
          label: "Case status",
          field: "status",
          type: "string",
          thClass: "width-sm hide-field-xs",
          tdClass: "align-left hide-field-xs",
          width: "20%"
        },
        {
          label: "Product description",
          field: "productDescription",
          type: "string",
          thClass: "width-sm hide-field-xs",
          tdClass: "align-left hide-field-xs",
          width: "25%"
        },
        {
          label: "Date added",
          type: "string",
          field(rowObj) {
            if(rowObj.createdOn){
              return rowObj.createdOn.substring(0,10)
            }
          },
          thClass: "width-sm hide-field-xs",
          tdClass: "hide-date-responsive hide-field-xs",
          width: "10%"
        },
        {
          label: "Actions",
          field: "actions",
          thClass: "th-actions text-nowrap",
          tdClass: "td-actions text-nowrap",
          width: "6%",
          sortable: false
        }
      ];
    }
  }
}


</script>
<style scoped src="@/assets/stylesheets/vgtStyles.css">
</style>